class FormatUtils {
  static number(value, decimalDigits = 2, thousandSeparator = '.', decimalSeparator = ',') {
    const v = Number(value);
    if (Number.isNaN(v)) {
      return value;
    }

    const parts = v.toFixed(decimalDigits).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, `$1${thousandSeparator}`);
    return parts.join(decimalSeparator);
  }

  static currency(value, symbol = 'R$', decimalDigits = 2, thousandSeparator = '.', decimalSeparator = ',') {
    const formatedCurrency = FormatUtils.number(value, decimalDigits, thousandSeparator, decimalSeparator);
    return `${symbol} ${formatedCurrency}`;
  }

  static distance(value, symbol = 'km', decimalDigits = 2, thousandSeparator = '.', decimalSeparator = ',') {
    const formatedDistance = FormatUtils.number(value, decimalDigits, thousandSeparator, decimalSeparator);
    return `${formatedDistance} ${symbol}`;
  }

  static padNumber(number) {
    return String(`0${number}`).slice(-2);
  }
}

export default FormatUtils;
